import { MARQUEE_ITEMS } from "@/data/content";
import { Diamond } from "@/components/decor";

function Row() {
  return (
    <div className="flex items-center gap-10 pr-10">
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-10">
          <span className="whitespace-nowrap text-label uppercase text-accent/70">{item}</span>
          <Diamond className="bg-signal/80" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      aria-label="Infrastructure domains"
      className="marquee-pause border-y border-line bg-paper py-6"
    >
      <div className="overflow-hidden">
        <div className="flex w-max animate-marquee" data-testid="domains-marquee">
          <Row />
          <div aria-hidden="true">
            <Row />
          </div>
        </div>
      </div>
    </section>
  );
}
